import React from "react";
import { Box, Grid, Typography, List, ListItem } from "@mui/material";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import SampleImage from "../../../src/assets/images/site/asic_design.jpg";
import ServiceImage from "../../../src/assets/images/site/asic-img2.png";
import PhyelementsMain from "../PhyElements/PhyelementsMain";
import "./OurServices.css";
import SiteFooter from "./ASIC/SiteFooter";

function PhysicalDesign() {
  return (
    <Box
      style={{
        backgroundColor: "#f9f9f9",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box sx={{ flex: 1 }}>
        <PhyelementsMain />
        {/* ---------- MIDDLE SECTION ---------- */}
        <Grid className="middle-section-title">
          PHYSICAL DESIGN AND VERIFICATION
        </Grid>

        <Grid
          className="middle-section-content"
          container
          sx={{ display: "flex", flexDirection: "row" }}
        >
          <Grid
            className="middle-section-points"
            item
            xs={12}
            md={4.5}
            order={{ xs: 2, md: 1 }}
            sx={{paddingRight:{xs:"20px",md:"0px"}}}
          >
            <List>
              <ListItem disablePadding sx={{ alignItems: "flex-start" }}>
                <KeyboardDoubleArrowRightIcon
                  sx={{ color: "#e31837", marginRight: 1 }}
                />
                <Box>
                  <Typography variant="h5" className="services-points-title">
                    Physical Design
                  </Typography>
                  <Typography variant="subtitle" className="services-points">
                    We provide end-to-end physical design services, from netlist
                    to GDSII, ensuring optimal power, performance, and area
                    (PPA). Our expertise covers floorplanning, placement, clock
                    tree synthesis (CTS), routing, and physical verification,
                    with a strong focus on timing closure, signal integrity, and
                    low-power implementation across advanced technology nodes.
                  </Typography>
                </Box>
              </ListItem>

              <ListItem disablePadding sx={{ alignItems: "flex-start" }}>
                <KeyboardDoubleArrowRightIcon
                  sx={{ color: "#e31837", marginRight: 1 }}
                />
                <Box>
                  <Typography variant="h5" className="services-points-title">
                    Static Timing Analysis (STA)
                  </Typography>
                  <Typography variant="subtitle" className="services-points">
                    We perform comprehensive static timing analysis to ensure
                    design closure across all process, voltage, and temperature
                    (PVT) corners. Our approach focuses on accurate timing
                    sign-off, constraint validation, and optimization to meet
                    stringent performance targets.
                  </Typography>
                </Box>
              </ListItem>

               <ListItem disablePadding sx={{ alignItems: "flex-start" }}>
                <KeyboardDoubleArrowLeftIcon
                  sx={{ color: "#e31837", marginRight: 1 }}
                />
                <Box>
                  <Typography variant="h5" className="services-points-title">
                    Physical Verification
                  </Typography>
                  <Typography variant="subtitle" className="services-points">
                    We deliver thorough physical verification, including DRC,
                    LVS, ERC, and antenna checks, ensuring full compliance with
                    foundry rules. Our team ensures clean sign-off and
                    manufacturability through robust verification methodologies.
                  </Typography>
                </Box>
              </ListItem>
            </List>
          </Grid>

          <Grid
            className="middle-section-image"
            item
            xs={4}
            md={2}
            order={{ xs: 1, md: 2 }}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              alignSelf: "center"
            }}
          >
            <img src={ServiceImage} alt="Service" />
          </Grid>

          <Grid
            className="middle-section-points"
            item
            xs={12}
            md={4.5}
            order={{ xs: 3, md: 2 }}
            sx={{paddingRight:{xs:"20px",md:"0px"}}}
          >
            <List>
              <ListItem disablePadding sx={{ alignItems: "flex-start" }}>
                <KeyboardDoubleArrowLeftIcon
                  sx={{ color: "#e31837", marginRight: 1 }}
                />
                <Box>
                  <Typography variant="h5" className="services-points-title">
                    Design for Test (DFT)
                  </Typography>
                  <Typography variant="subtitle" className="services-points">
                    We support DFT implementation including scan insertion,
                    ATPG, and test coverage analysis. Our solutions ensure high
                    fault coverage, improved testability, and reduced test costs
                    for complex SoCs.
                  </Typography>
                </Box>
              </ListItem>

              <ListItem disablePadding sx={{ alignItems: "flex-start" }}>
                <KeyboardDoubleArrowLeftIcon
                  sx={{ color: "#e31837", marginRight: 1 }}
                />
                <Box>
                  <Typography variant="h5" className="services-points-title">
                    Power Integrity & Signal Integrity
                  </Typography>
                  <Typography variant="subtitle" className="services-points">
                    We analyze and optimize power and signal integrity,
                    including IR drop, electromigration (EM), and noise
                    analysis. Our approach ensures reliable operation and
                    long-term durability of the design under real-world
                    conditions.
                  </Typography>
                </Box>
              </ListItem>
            </List>
          </Grid>
        </Grid>
      </Box>
      <SiteFooter />
    </Box>
  );
}

export default PhysicalDesign;
